export default "__VITE_ASSET__CBMHS7ZK__"